module.exports = __webpack_public_path__ + "img/frame (277).ff1bd261.jpg";